import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
    selector: 'fi-checklist2-schedule-description',
    templateUrl: './fi-checklist2-schedule-description.component.html',
    styleUrls: ['./fi-checklist2-schedule-description.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-schedule-description' },
    standalone: false,
})
export class FiChecklist2ScheduleDescriptionComponent {
    @Input() isAudit: boolean;
    @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;
    @HostBinding('class.content-expanded') get isPanelExpanded(): boolean {
        return this.expansionPanel?.expanded;
    }

    constructor(private appTextService: AppTextService) {}

    get checklistScheduleExplanationHeadingLabel(): string {
        return this.getChecklistScheduleLabel(
            'checklist.checklist_schedule_description_heading',
            'checklist.checklist_audit_v2',
            'checklist.checklist_v2',
        );
    }

    get checklistExplanationLabel(): string {
        return this.getChecklistScheduleLabel(
            'checklist.checklist_explanation',
            'checklist.checklist_audit_v2',
            'checklist.checklist_v2',
        );
    }

    get scheduleExplanationLabel(): string {
        return this.getChecklistScheduleLabel(
            'checklist.schedule_explanation',
            'checklist.checklist_schedule_audit_v2',
            'checklist.checklist_schedule_v2',
        );
    }

    get createChecklistLabel(): string {
        return this.getChecklistScheduleLabel(
            'checklist.create_item',
            'checklist.checklist_audit_v2',
            'checklist.checklist_v2',
        );
    }

    get shareChecklistLabel(): string {
        return this.getChecklistScheduleLabel(
            'checklist.share_item',
            'checklist.checklist_audit_v2',
            'checklist.checklist_v2',
        );
    }

    get createScheduleLabel(): string {
        return this.getChecklistScheduleLabel(
            'checklist.create_item',
            'checklist.checklist_schedule_audit_v2',
            'checklist.checklist_schedule_v2',
        );
    }

    get shareScheduleLabel(): string {
        return this.getChecklistScheduleLabel(
            'checklist.share_item',
            'checklist.checklist_schedule_audit_v2',
            'checklist.checklist_schedule_v2',
        );
    }

    private getChecklistScheduleLabel(mainText: string, auditItemText: string, regularItemText: string): string {
        return this.appTextService.get(mainText, {
            '{0}': this.appTextService.get(this.isAudit ? auditItemText : regularItemText),
        });
    }
}
